// `user.role` (singular) is a coarse 'admin' | 'employee' label collapsed from
// clearance_level <= 5 (see authService.ts issueSessionForUser) - it's what
// access-gating checks across the app key off, and changing its meaning would
// touch RBAC everywhere. This helper is display-only: it picks a real role
// name out of `user.roles` (the actual role codes) so a Manager, Department
// Head, or Branch Admin doesn't show up labeled "admin" next to their name
// when the sidebar/permissions they actually have are far narrower.
const ROLE_PRIORITY = [
    'super_admin',
    'admin',
    'hr_admin',
    'branch_admin',
    'department_head',
    'manager',
    'supervisor',
    'employee',
];

const titleCase = (code: string): string =>
    code
        .split('_')
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

export function getDisplayRole(roles?: string[] | null, fallback?: string | null): string {
    const list = (roles || []).map((r) => r.toLowerCase());
    if (list.length === 0) {
        return fallback ? titleCase(fallback) : '';
    }
    for (const code of ROLE_PRIORITY) {
        if (list.includes(code)) return titleCase(code);
    }
    // Unrecognized/custom role code (e.g. one created in Security Center) -
    // show it formatted rather than falling back to the coarse label.
    return titleCase(list[0]);
}
